unit SystemInvoiceNumberSetup;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.DBCtrls,
  Vcl.Controls, WEBLib.ExtCtrls;

type
  TfrmSystemInvoiceNumberSetup = class(TForm)
    WebPanel14: TPanel;
    lblTransactionType: TLabel;
    WebLabel36: TLabel;
    WebLabel37: TLabel;
    dblTransactionType: TDBLookupComboBox;
    edtPrefix: TDBEdit;
    edtNumber: TDBEdit;
    WebButton1: TButton;
    WebButton2: TButton;
    WebPanel1: TPanel;
  private
    { Private declarations }
  public
    { Public declarations }
    iState : integer;
  protected procedure LoadDFMValues; override; end;

var
  frmSystemInvoiceNumberSetup: TfrmSystemInvoiceNumberSetup;

implementation

{$R *.dfm}

procedure TfrmSystemInvoiceNumberSetup.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel14 := TPanel.Create(Self);
  lblTransactionType := TLabel.Create(Self);
  WebLabel36 := TLabel.Create(Self);
  WebLabel37 := TLabel.Create(Self);
  dblTransactionType := TDBLookupComboBox.Create(Self);
  edtPrefix := TDBEdit.Create(Self);
  edtNumber := TDBEdit.Create(Self);
  WebButton1 := TButton.Create(Self);
  WebButton2 := TButton.Create(Self);
  WebPanel1 := TPanel.Create(Self);

  WebPanel14.BeforeLoadDFMValues;
  lblTransactionType.BeforeLoadDFMValues;
  WebLabel36.BeforeLoadDFMValues;
  WebLabel37.BeforeLoadDFMValues;
  dblTransactionType.BeforeLoadDFMValues;
  edtPrefix.BeforeLoadDFMValues;
  edtNumber.BeforeLoadDFMValues;
  WebButton1.BeforeLoadDFMValues;
  WebButton2.BeforeLoadDFMValues;
  WebPanel1.BeforeLoadDFMValues;
  try
    Name := 'frmSystemInvoiceNumberSetup';
    Width := 640;
    Height := 431;
    WebPanel14.SetParentComponent(Self);
    WebPanel14.Name := 'WebPanel14';
    WebPanel14.Left := 0;
    WebPanel14.Top := 0;
    WebPanel14.Width := 640;
    WebPanel14.Height := 431;
    WebPanel14.Align := alClient;
    WebPanel14.ChildOrder := 2;
    WebPanel14.Color := clSilver;
    WebPanel14.TabOrder := 0;
    lblTransactionType.SetParentComponent(WebPanel14);
    lblTransactionType.Name := 'lblTransactionType';
    lblTransactionType.Left := 150;
    lblTransactionType.Top := 106;
    lblTransactionType.Width := 92;
    lblTransactionType.Height := 15;
    lblTransactionType.Caption := 'Transaction Type:';
    lblTransactionType.HeightPercent := 100.000000000000000000;
    lblTransactionType.WidthPercent := 100.000000000000000000;
    WebLabel36.SetParentComponent(WebPanel14);
    WebLabel36.Name := 'WebLabel36';
    WebLabel36.Left := 150;
    WebLabel36.Top := 180;
    WebLabel36.Width := 32;
    WebLabel36.Height := 15;
    WebLabel36.Caption := 'Prefix:';
    WebLabel36.HeightPercent := 100.000000000000000000;
    WebLabel36.WidthPercent := 100.000000000000000000;
    WebLabel37.SetParentComponent(WebPanel14);
    WebLabel37.Name := 'WebLabel37';
    WebLabel37.Left := 150;
    WebLabel37.Top := 250;
    WebLabel37.Width := 50;
    WebLabel37.Height := 15;
    WebLabel37.Caption := 'Number: ';
    WebLabel37.HeightPercent := 100.000000000000000000;
    WebLabel37.WidthPercent := 100.000000000000000000;
    dblTransactionType.SetParentComponent(WebPanel14);
    dblTransactionType.Name := 'dblTransactionType';
    dblTransactionType.Left := 150;
    dblTransactionType.Top := 127;
    dblTransactionType.Width := 331;
    dblTransactionType.Height := 22;
    dblTransactionType.HeightPercent := 100.000000000000000000;
    dblTransactionType.WidthPercent := 100.000000000000000000;
    dblTransactionType.DataField := 'DESCRIPTION';
    edtPrefix.SetParentComponent(WebPanel14);
    edtPrefix.Name := 'edtPrefix';
    edtPrefix.Left := 150;
    edtPrefix.Top := 201;
    edtPrefix.Width := 163;
    edtPrefix.Height := 22;
    edtPrefix.ChildOrder := 4;
    edtPrefix.HeightPercent := 100.000000000000000000;
    edtPrefix.WidthPercent := 100.000000000000000000;
    edtPrefix.DataField := 'PREFIX';
    edtNumber.SetParentComponent(WebPanel14);
    edtNumber.Name := 'edtNumber';
    edtNumber.Left := 150;
    edtNumber.Top := 271;
    edtNumber.Width := 331;
    edtNumber.Height := 22;
    edtNumber.ChildOrder := 5;
    edtNumber.HeightPercent := 100.000000000000000000;
    edtNumber.WidthPercent := 100.000000000000000000;
    edtNumber.DataField := 'SUFFIX';
    WebButton1.SetParentComponent(WebPanel14);
    WebButton1.Name := 'WebButton1';
    WebButton1.Left := 150;
    WebButton1.Top := 352;
    WebButton1.Width := 96;
    WebButton1.Height := 25;
    WebButton1.Caption := 'WebButton1';
    WebButton1.ChildOrder := 6;
    WebButton1.HeightPercent := 100.000000000000000000;
    WebButton1.WidthPercent := 100.000000000000000000;
    WebButton2.SetParentComponent(WebPanel14);
    WebButton2.Name := 'WebButton2';
    WebButton2.Left := 385;
    WebButton2.Top := 352;
    WebButton2.Width := 96;
    WebButton2.Height := 25;
    WebButton2.Caption := 'WebButton2';
    WebButton2.ChildOrder := 7;
    WebButton2.HeightPercent := 100.000000000000000000;
    WebButton2.WidthPercent := 100.000000000000000000;
    WebPanel1.SetParentComponent(WebPanel14);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 640;
    WebPanel1.Height := 41;
    WebPanel1.Align := alTop;
    WebPanel1.Caption := 'System Number Setup';
    WebPanel1.ChildOrder := 8;
    WebPanel1.Color := clSilver;
    WebPanel1.Font.Charset := DEFAULT_CHARSET;
    WebPanel1.Font.Color := clWindowText;
    WebPanel1.Font.Height := -16;
    WebPanel1.Font.Name := 'Segoe UI';
    WebPanel1.Font.Style := [fsBold];
    WebPanel1.ParentFont := False;
    WebPanel1.TabOrder := 5;
  finally
    WebPanel14.AfterLoadDFMValues;
    lblTransactionType.AfterLoadDFMValues;
    WebLabel36.AfterLoadDFMValues;
    WebLabel37.AfterLoadDFMValues;
    dblTransactionType.AfterLoadDFMValues;
    edtPrefix.AfterLoadDFMValues;
    edtNumber.AfterLoadDFMValues;
    WebButton1.AfterLoadDFMValues;
    WebButton2.AfterLoadDFMValues;
    WebPanel1.AfterLoadDFMValues;
  end;
end;

end.